module.exports = __webpack_public_path__ + "img/vegetable-chili-peppers-190x100.75c01a8b.jpg";